<script>
  import { goto } from '@sapper/app';
  import Button from '../Button.svelte';

  import { cartDetails } from '../../stores/Cart.js';

  export let show = false;

  function goToCart() {
    show = false;
    goto('/cart');
  }
</script>

{#if show}
  <div class="parent">
    <h4>Your Cart</h4>

    {#if $cartDetails?.items.length > 0}
      <div class="item-container">
        {#each $cartDetails.items as item}
          <div class="item">
            <div class="grid">
              <div class="preview">
                <img class="preview-img" src={item.cartPreviewImage} alt="Product" />
              </div>
              <div class="info">
                <small>{item.itemSummary.collection}</small>
                {#if item.itemSummary.customised}
                  <strong>Custom Uniforms</strong>
                {:else}
                  <strong>Blank Uniforms</strong>
                {/if}
                <span class="price">${(item.totalPrice / 100).toFixed(2)}</span>
              </div>
            </div>
          </div>
        {/each}
      </div>
      <div class="total">
        <strong>Order Total</strong>
        <strong class="price">${($cartDetails.total / 100).toFixed(2)}</strong>
      </div>

      <div class="full">
        <Button clickFn={goToCart} label="Go to Cart" type="black-o" />
      </div>
    {:else}
      <div class="empty">
        <p>Your cart is empty</p>
      </div>
    {/if}
  </div>
{/if}

<style>
  .parent {
    position: absolute;
    top: 6rem;
    /* Set back to 0 when we add back Auth */
    /* left: 0; */
    right: 0.5rem;
    background-color: #fff;
    border: 2px solid #000;
    padding: 2rem;
  }

  .full {
    display: grid;
  }

  .total {
    background-color: #ddd;
    padding: 2rem;
    color: #000;
    margin: 1rem 0;
    display: flex;
    justify-content: space-between;
  }

  .total .price {
    color: #fe5900;
  }

  h4 {
    color: #fe5900;
  }

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .preview {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .preview-img {
    max-width: 6rem;
    width: auto;
    height: auto;
  }

  .item-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-top: 2rem;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .info {
    color: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  strong,
  .price {
    display: block;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-family: 'Oswald', sans-serif;
  }

  small {
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #999;
    font-weight: 600;
    font-size: 0.8rem;
  }

  .price {
    color: #fe5900;
    font-weight: 700;
    font-size: 1.2rem;
  }

  .empty {
    padding: 2rem;
    font-size: 1.2rem;
    color: black;
    font-family: 'Inter', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
</style>
